jQuery(document).ready(function() {
	/*menu slider toggles*/
	jQuery('.logo_centered_right_hamb a.left_hamburger').on('click', function(e){
	    e.preventDefault();
	    jQuery('.right-popup-menu').show("slide", { direction: "right" }, 300);
	});
	jQuery('logo_centered_right_hamb a.hamburger_close').on('click', function(e){
	    e.preventDefault();
	    jQuery('.right-popup-menu').hide("slide", { direction: "right" }, 300);
	});

	jQuery('.logo_centered_left_hamb a.left_hamburger').on('click', function(e){
	    e.preventDefault();
	    jQuery('.left-popup-menu').show("slide", { direction: "left" }, 300);
	});
	jQuery('.left-popup-menu a.hamburger_close').on('click', function(e){
	    e.preventDefault();
	    var direction = jQuery('.left-popup-menu').hasClass('popup-from-left') ? 'left' : 'right';
	    jQuery('.left-popup-menu').hide("slide", { direction: direction }, 300);
	    jQuery('.left-popup-menu .header-menu__item.submenu-open').removeClass('submenu-open').children('.sub-menu').hide();
	});

	jQuery('.mobile_header a.left_hamburger').on('click', function(e){
	    e.preventDefault();
	    var direction = jQuery('.left-popup-menu').hasClass('popup-from-left') ? 'left' : 'right';
	    jQuery('.left-popup-menu').show("slide", { direction: direction }, 300);
	});

	jQuery('.left-popup-menu').on('click', '.open_submenu', function(e) {
	    e.preventDefault();
	    var $item = jQuery(this).closest('.header-menu__item');
	    var $subMenu = $item.children('.sub-menu');
	    var isOpen = $item.hasClass('submenu-open');
	    $item.toggleClass('submenu-open', !isOpen);
	    if (isOpen) {
	        $subMenu.slideUp(200);
	    } else {
	        $subMenu.slideDown(200);
	    }
	});

	jQuery('a.banner-close').on('click', function(e){
	    e.preventDefault();
	    jQuery('.header_notif').slideUp();
	});

	var $stickyInner = jQuery('.header-container[data-sticky="true"]');
	if ($stickyInner.length) {
		var $header = jQuery('.cru_header_logo_centered');
		var headerHeight = $header.outerHeight();
		if ($stickyInner.data('sticky-padding') === true) {
			jQuery('body').css('padding-top', headerHeight + 'px');
		}

		var lastScrollTop = 0;
		var scrollThreshold = 8;

		jQuery(window).on('scroll.stickyHeader', function() {
			var st = jQuery(this).scrollTop();
			var diff = st - lastScrollTop;

			if (Math.abs(diff) < scrollThreshold) return;

			if (diff > 0 && st > headerHeight) {
				$header.addClass('scrolled-down');
			} else {
				$header.removeClass('scrolled-down');
			}

			lastScrollTop = st;
		});
	}


	setTimeout(function(){
		if(jQuery('.hero_main_container').length > 0){
			var currentSlide = jQuery('.hero_main_container').slick('slickCurrentSlide');
			var header_type = jQuery('#slick-slide0'+currentSlide).attr('header-type');
			jQuery('.cru_header_logo_centered').removeClass('dark');
			jQuery('.cru_header_logo_centered').removeClass('light');
			jQuery('.cru_header_logo_centered').addClass(header_type);
		}
	}, 3000);


	jQuery('.hero_main_container').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		var header_type = jQuery('#slick-slide0'+nextSlide).attr('header-type');
		jQuery('.cru_header_logo_centered').removeClass('dark');
		jQuery('.cru_header_logo_centered').removeClass('light');
		jQuery('.cru_header_logo_centered').addClass(header_type);
	});
});
 